import React from 'react';
import { ArrowDown } from 'lucide-react';

const HeroSection = ({ content }) => {
  if (!content) return null;

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={content.image}
          alt={content.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/70" />
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-6 max-w-4xl mx-auto">
          <div className="space-y-6 animate-fadeIn">
            <p className="text-lg md:text-xl font-light tracking-wider uppercase text-amber-200">
              {content.subtitle}
            </p>
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight">
              {content.title}
            </h1>
            <p className="text-xl md:text-2xl font-light text-slate-200 max-w-2xl mx-auto">
              {content.description}
            </p>
            <div className="flex items-center justify-center gap-2 text-sm md:text-base text-amber-200">
              <svg
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="font-medium">{content.location}</span>
            </div>
            <div className="pt-8">
              <a
                href={content.ctaLink}
                className="inline-block px-10 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                {content.ctaText}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ArrowDown className="w-6 h-6 text-white/70" />
      </div>
    </section>
  );
};

export default HeroSection;
